module.exports = __webpack_public_path__ + "media/images/nav/icon_5-e9f40ccdbabdc473be1d4286d9569ba8.svg";